import lodash from "lodash";

export const buildData = (dataState, dataEdit = null) => {
  const {
    topic,
    startTime,
    endTime,
    location,
    instructors,
    selectedCategories,
    notes,
    generalFiles,
    instructorsFiles,
    allowSignUps,
    classLimit,
    status,
  } = dataState;

  const data = new FormData();
  data.append("topic", topic);
  data.append("notes", notes);
  data.append("allow_sign_ups", allowSignUps);
  data.append("class_limit", allowSignUps ? classLimit : null);
  data.append("start_time", startTime);
  data.append("end_time", endTime);
  data.append("location_id", location);
  data.append("status", status);

  if (dataEdit) {
    let tmp = [];
    dataEdit.instructors.forEach(instructor => {
      data.append("in_service_instructors_attributes[][id]", instructor.id);
      data.append("in_service_instructors_attributes[][user_id]", instructor.value);

      if (lodash.findIndex(instructors, { value: instructor.value }) === -1) {
        data.append("in_service_instructors_attributes[][_destroy]", "true");
      }
      tmp.push(instructor.value);
    });
    instructors.forEach(instructor => {
      if (!tmp.includes(instructor.value)) {
        data.append("in_service_instructors_attributes[][user_id]", instructor.value);
      }
    });

    tmp = [];
    dataEdit.selectedCategories.forEach(category => {
      data.append("in_service_category_in_services_attributes[][id]", category.id);
      data.append("in_service_category_in_services_attributes[][in_service_category_id]", category.value);

      if (lodash.findIndex(selectedCategories, { value: category.value }) === -1) {
        data.append("in_service_category_in_services_attributes[][_destroy]", "true");
      }
      tmp.push(category.value);
    });

    selectedCategories.forEach(category => {
      if (!tmp.includes(category.value)) {
        data.append("in_service_category_in_services_attributes[][in_service_category_id]", category.value);
      }
    });

    generalFiles.forEach(file => {
      if (file.id && file._destroy) {
        data.append("attachments_attributes[][id]", file.id);
        data.append("attachments_attributes[][_destroy]", "true");
      } else if (!file.id) {
        data.append("attachments[]", file, file.name);
      }
    });
    instructorsFiles.forEach(file => {
      if (file.id && file._destroy) {
        data.append("instructor_attachments_attributes[][id]", file.id);
        data.append("instructor_attachments_attributes[][_destroy]", "true");
      } else if (!file.id) {
        data.append("instructor_attachments[]", file, file.name);
      }
    });
  } else {
    selectedCategories.forEach(category => {
      data.append("in_service_category_in_services_attributes[][in_service_category_id]", category.value);
    });

    instructors.forEach(instructor => {
      data.append("in_service_instructors_attributes[][user_id]", instructor.value)
    });

    generalFiles.forEach(file => {
      data.append("attachments[]", file, file.name);
    });

    instructorsFiles.forEach(file => {
      data.append("instructor_attachments[]", file, file.name);
    });
  }

  return data;
};
